import { EbiCondition, IEbiField } from "modules/ebiForms/typings";

// Pola wspólne pakietu „oświata, parkowanie i straż gminna” (D4–D8, E5–E7): dziecko (uczeń) wskazane we wniosku, jego
// adres, gdy inny niż wnioskodawcy, oraz rachunek bankowy do wypłaty świadczenia albo zwrotu kosztów.

/** Imię, nazwisko i PESEL dziecka (ucznia) — prefiks „uczen” daje kody uczenImie, uczenNazwisko, uczenPesel. */
export const childIdentityFields = (prefix: string): IEbiField[] => [
  { code: `${prefix}Imie`, type: "text", label: "Imię", required: true, width: "half", maxLength: 100 },
  { code: `${prefix}Nazwisko`, type: "text", label: "Nazwisko", required: true, width: "half", maxLength: 100 },
  { code: `${prefix}Pesel`, type: "pesel", label: "PESEL", required: true, width: "half" },
];

/** Adres zamieszkania dziecka — tylko gdy inny niż adres wnioskodawcy (przełącznik i trzy pola adresu). */
export const childAddressFields = (prefix: string, who = "Dziecko"): IEbiField[] => {
  const otherAddress: EbiCondition = { field: `${prefix}InnyAdres`, equals: true };

  return [
    { code: `${prefix}InnyAdres`, type: "checkbox", label: `${who} mieszka pod innym adresem niż wnioskodawca` },
    {
      code: `${prefix}Adres`,
      type: "text",
      label: "Adres zamieszkania — ulica, numer domu i lokalu",
      required: true,
      visibleWhen: otherAddress,
      maxLength: 200,
    },
    { code: `${prefix}KodPocztowy`, type: "postalCode", label: "Kod pocztowy", required: true, visibleWhen: otherAddress, width: "third", placeholder: "00-000" },
    { code: `${prefix}Miejscowosc`, type: "text", label: "Miejscowość", required: true, visibleWhen: otherAddress, width: "twoThirds", maxLength: 100 },
  ];
};

/** Numer rachunku bankowego (wypłata świadczenia, dofinansowania albo zwrot kosztów). */
export const bankAccountField = (code: string, label: string, options: Partial<IEbiField> = {}): IEbiField => ({
  code,
  type: "text",
  label,
  maxLength: 40,
  placeholder: "26 cyfr, np. 12 3456 7890 1234 5678 9012 3456",
  ...options,
});
